import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Auth } from '../../../core/auth/auth';
import { Avatar } from '../avatar/avatar';

export type UserRole = 'admin' | 'sub_admin' | 'employee' | 'super_user';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, Avatar],
  templateUrl: './userprofile.html',
  styleUrl: './userprofile.scss',
})
export class UserProfile implements OnChanges {
  @ViewChild('userProfileWrapper') userProfileWrapper!: ElementRef;

  @Input() userProfile: string | null = null;
  @Input() clientLogo: string | null = null;

  @Input() firstName: string | null = null;
  @Input() lastName: string | null = null;

  @Output() opened = new EventEmitter<void>();

  private readonly auth = inject(Auth);
  private readonly router = inject(Router);

  isDropdownOpen = false;
  logoHasError = false;

  get loggedUser() {
    return this.auth.currentUser();
  }

  get userRole(): UserRole {
    switch (this.loggedUser?.role_type) {
      case 'admin':
        return 'admin';
      case 'sub_admin':
        return 'sub_admin';
      case 'super_user':
        return 'super_user';
      default:
        return 'employee';
    }
  }

  get showChangePassword(): boolean {
    return this.loggedUser?.role_type !== 'super_admin';
  }

  get avatarFirstName(): string | undefined {
    const user = this.loggedUser as Record<string, any> | null | undefined;
    return this.firstName ?? user?.['firstname'] ?? user?.['firstName'] ?? user?.['first_name'];
  }

  get avatarLastName(): string | undefined {
    const user = this.loggedUser as Record<string, any> | null | undefined;
    return this.lastName ?? user?.['lastname'] ?? user?.['lastName'] ?? user?.['last_name'];
  }

  get canSeeProfile(): boolean {
    const role = Number(this.loggedUser?.role);
    return role === 3 || role === 4;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientLogo']) {
      this.logoHasError = false;
    }
  }

  onLogoError(): void {
    this.logoHasError = true;
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.opened.emit();
    }
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  onChangePasswordClick(): void {
    this.closeDropdown();
    this.router.navigate(['/changepassword']);
  }

  logout(): void {
    this.auth.logout().subscribe({
      next: (resp) => {
        resp.message;
      },
    });
    this.auth.updateUser(null);
    localStorage.removeItem('default_company');
    localStorage.removeItem('selectedMenuID');
    localStorage.removeItem('activeMenuName');
    localStorage.removeItem('activeMenu');
    this.auth.loggedIn.next(false);
    this.router.navigate(['/']);
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isDropdownOpen && this.userProfileWrapper && !this.userProfileWrapper.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }
}
